import { Product } from "./product.model";

export interface cateringOrder {
  userId: string | null;
  orderId: string;
  products: {
    product: Product,
    quantity: number
  }[],
  orderNumber: number;
  totalPrice: number;
  isDelivery: boolean;
  status: string, //default pending
  isPaid: boolean,
  paymentMethod: string,
  Delivered: boolean,
  pickupOrDeliveryTime: number, //timestamp
  commentToRestaurant: string,
  meetingPurpose?: string;
  participants?: string;
  /** Guest "order by invoice" checkout (no login, no corporate customer record). */
  orderSource?: string;
  /** Tilaisuuden isäntä/emäntä — event host/hostess. */
  eventHost?: string;
  /** Henkilömäärä — number of attendees. */
  numberOfAttendees?: number | null;
  /** Erikoisruokavaliot — special diets, free text. */
  specialDiets?: string;
  /** Viitetiedot — invoice reference, distinct from costCenter. */
  invoiceReference?: string;
  /** Tilaisuuden ajankohta (end) — optional event end timestamp. */
  eventEndTime?: number | null;
  deliveryLocation?: {
    connectedCompany: string,
    organizationNumber: string,
    vatNumber: string,
    locationId: string,
    invoiceSettings: {
      deliveryMethod: string,
      invoiceEmail: string,
      paymentTermsDays: number
    },
    billingContact: {
      email: string,
      name: string,
      phone: string
    },
    billingAddress: {
      city: string,
      country: string,
      postalCode: string,
      street: string
    },
    locationName: string,
    deliveryRoom: string,
    entranceCode: string,
    floor: string,
    subLocationFloor?: string,
    subLocationDoorCode?: string,
    address: string,
    postalCode: string,
    city: string,
    costCenter?: string,
  }
  customer: {
    firstName: string,
    lastName: string,
    email: string,
    phone: string
    city: string,
    address: string,
    postalCode: string
  },
  restaurantInfo: {
    name: string,
    email: string,
    address: string,
    city: string,
    postalCode: string,
    companyName: string,
    phoneNumber: string
  },
  createdAt: number,
  updatedAt: number,
  timeSlots?:{}

}

export class PaymentV2Response {
  idempotencyKey!: string;
  success!: boolean;
  approvedOrder?: any;
  providerData?: any;
  error?: {
    showResponseText: boolean,
    languageCode: string,
    responseText: string,
    resetOrder?: boolean;
  };
  missing?: any;
  updatedCart?: any;
}
